export const SEARCH_PROPERTY_DOMUS = 'SEARCH_PROPERTY_DOMUS'
export const ARRAY_LIST_AMENITIES_PROPERTY_DOMUS = 'ARRAY_LIST_AMENITIES_PROPERTY_DOMUS'
export const ARRAY_LIST_IMAGES_PROPERTY_DOMUS = 'ARRAY_LIST_IMAGES_PROPERTY_DOMUS'
export const ARRAY_LIST_IMAGES360_PROPERTY_DOMUS = 'ARRAY_LIST_IMAGES360_PROPERTY_DOMUS'
export const ARRAY_LIST_VIDEOS_PROPERTY_DOMUS = 'ARRAY_LIST_VIDEOS_PROPERTY_DOMUS'
export const ARRAY_LIST_TOURS_PROPERTY_DOMUS = 'ARRAY_LIST_TOURS_PROPERTY_DOMUS'
export const IS_LOADING_FORM_PROPERTY_DOMUS = 'IS_LOADING_FORM_PROPERTY_DOMUS'
export const FORM_DATA_PROPERTY_DOMUS = 'FORM_DATA_PROPERTY_DOMUS'
